<template>
    <div>
        <el-input v-model="searchContent" size="mini" placeholder="输入关键字搜索" style="width: 200px;" />
        <el-button type="primary" :icon="Search" @click="getSearch()">搜索</el-button>
    </div>
    <el-scrollbar max-height="800px">
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
            <el-table-column fixed prop="id" label="资源id" width="150" />
            <el-table-column prop="title" label="资源标题" width="120" />
            <el-table-column prop="content" label="资源描述" width="800" />
            <el-table-column prop="remarks" label="备注" width="120" />
            <el-table-column fixed="right" label="操作" width="120">
                <template v-slot="scope">
                    <el-button link type="primary" size="small" @click="handleDetailShow(scope.row)">查看</el-button>
                    <RouterLink :to="handleUpdate(scope.row)"><el-button link type="primary" size="small">修改</el-button>
                    </RouterLink>
                    <el-button link type="primary" size="small" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-scrollbar>
    <el-pagination background layout="prev, pager, next" :page-size="pageSize" :current-page="currentPage"
        :total="totalCount" @current-change="handleCurrentChange" style="margin: 10px 0 ;" />

    <el-dialog title="资源详情" v-model="resourceDetailShow">
        <el-scrollbar max-height="600px">
            <div v-html="contentHtml"></div>
        </el-scrollbar>
        <div slot="footer" class="dialog-footer">

        </div>
    </el-dialog>

</template>

<script>
import { ElButton, ElMessage, ElLoading } from 'element-plus';
const axios = require("axios");
import { inject } from 'vue'


export default {
    components: {
        ElButton,
    },
    data() {
        return {
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            searchContent: "",
            loading: true,
            serverUrl: inject('serverUrl'),
            fileUrl: inject('fileUrl'),
            tableData: [],
            resourceDetailShow: false,
            contentHtml: ''
        }
    },

    mounted() {
        this.getResource(this.searchContent)

    },

    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getResource(this.searchContent)
        },
        async handleDetailShow(e) {
            this.resourceDetailShow = true;
            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            console.log(e);

            const res = await axios.post(
                this.serverUrl + "/api/resource/detail", // 请求后端的 URL
                {
                    "resourceId": e.id,
                },
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                        "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
                        "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
                    },
                }
            );
            console.log(res);
            console.log(res.data.obj.toolsResource.content);
            this.contentHtml = res.data.obj.toolsResource.content;
            loading.close()
        },
        handleUpdate(row) {
            return "/updateproduct/" + row.id;
        },
        getSearch() {
            this.getResource(this.searchContent);
        },
        async getResource(content) {
            var that = this;
            this.loading = true;
            const res = await axios.post(
                this.serverUrl + "/api/resource/list", // 请求后端的 URL
                {
                    "content": content,
                    "limit": that.pageSize,
                    "offset": (that.currentPage - 1) * that.pageSize
                },
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                        "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
                        "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
                    },
                }
            );
            console.log(res);
            that.tableData = res.data.obj.toolsResources;
            that.totalCount = res.data.obj.resourceCount;
            that.loading = false;
        },
    }
};
</script>

<style>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>